var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn-icon',{attrs:{"color":_vm.favorite?'warning':'grey',"icon":_vm.model.loading?'progress-star':'star',"title":_vm.favorite?'Из избранного':'В избранное'},on:{"click":function($event){return _vm.model.setFavorite(!_vm.favorite)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }